import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ToastComponent {
  message = 'A toast message goes here.';
  visible = false;

  show(message: string) {
    this.message = message;
    this.visible = true;

    setTimeout(() => {
      this.close();
    }, 3000);
  }

  close() {
    this.visible = false;
  }
}